<template>
  <div ref="StageDynamicBudget" class="flex flex-wrap mb-2">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <div class="grid grid-cols-12">
        <span>動態預算</span>
        <div class="col-span-10 text-sm leading-6 text-gray-400">開啟時，系統將自動根據每階段成效，動態調配總預算比例</div>
        <div>
          <InputSwitch :disabled="editPageType" v-model="viewDatalistData.useDynamicBudget" class="float-right"/>
        </div>
      </div>
      <div v-if="viewDatalistData.useDynamicBudget == true">
        <div v-for="(item, index) in viewDatalistData.budgetDynamicRuleRaise" :key="index" class="border rounded-md mt-2">
          <div class="grid grid-cols-4 gap-2 border-b border-dashed p-4">
            <div class="pr-2">
              <div>
                <span class="text-grap-700 align-middle text-sm">預算區間</span>
              </div>
              <div class="flex">
                <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-1/2 h-10 mr-1">
                  <input
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    v-model="item.min_budget"
                    :disabled="editPageType"
                    oninput = "value=value.replace(/[^\d]/g,'')"
                  />
                  <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
                </div>
                <div class="leading-10"> ~ </div>
                <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-1/2 h-10 ml-1">
                  <input
                    type="text"
                    class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                    v-model="item.max_budget"
                    :disabled="editPageType"
                    oninput = "value=value.replace(/[^\d]/g,'')"
                  />
                  <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
                </div>
              </div>
            </div>
            <div class="pr-2">
              <div>
                <span class="text-grap-700 align-middle text-sm">判斷頻率</span>
              </div>
              <div class="border border-gray-200 rounded-md p-1">
                <div style="height:30px;">
                  每
                  <Dropdown v-model="item.rule_freq" optionLabel="name" optionValue="code" :options="timeType" placeholder="請選擇條件" class="w-3/8" :disabled="editPageType" style="height: 30px; line-height:14px;"/>
                  判斷一次
                </div>
              </div>
            </div>
            <div class="pr-2">
              <div>
                <span class="text-grap-700 align-middle text-sm">預算擴充比率</span>
              </div>
              <div class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-full h-10">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  v-model="item.pct_dynamic"
                  :disabled="editPageType"
                  oninput = "value=value.replace(/[^\d]/g,'')"
                  @input="validateInput"
                />
                <span class="text-xs text-gray-400">%</span>
              </div>
            </div>
          </div>
          <div v-if="false">
            <div v-for="(filtersItem, filtersIndex) in item.filters" :key="filtersIndex">
              <div class="grid grid-cols-12 p-2">
                <div v-if="false" class="col-span-2">
                  <Dropdown v-if="filtersIndex == 1" v-model="filtersItem.logicType" optionLabel="name" optionValue="code" :options="logicType" placeholder="請選擇條件" @change="changeStopLogicType(filtersItem.logicType)" class="w-full" :disabled="editPageType"/>
                  <span v-else-if="filtersIndex > 1" class="pl-2" style="line-height:42px;">{{filtersItem.logicType}}</span>
                </div>
                <div class="col-span-2">
                  <Dropdown v-model="filtersItem.field" optionLabel="name" optionValue="code" :options="field" placeholder="請選擇條件" class="w-full"/>
                </div>
                <div class="col-span-2">
                  <Dropdown v-model="filtersItem.operator" optionLabel="name" optionValue="code" :options="compareType" placeholder="請選擇條件" class="w-full"/>
                </div>
                <div class="col-span-5">
                  <div class="bg-white items-center p-1 shadow-sm border border-gray-200 w-full" style="height:42px;">
                    <input
                      type="text"
                      class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                      style="line-height:32px;"
                      v-model="filtersItem.value"
                      placeholder="輸入數值"
                      @keyup="num(filtersItem.value, currencyListData.currency_offset, 'budget_extra_list', filtersItem.field, index)"
                    />
                  </div>
                </div>
                <div v-if="false" class="border border-gray-200">
                  <div class="p-2 cursor-pointer" @click="clearBudgetExtraItems(filtersIndex)">
                    <img class="w-6 h-6 cursor-pointer" style="margin: 0 auto;" src="../../assets/clear.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RuleRaiseGroup v-model:filters="viewDatalistData.budgetDynamicRuleRaise" v-bind:editPage="editPageType" :conditionCount="ruleFrequencyConditionCount" :canAddCondition="canRaiseAddCondition" @changeData="changeDataFilters"/>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
</template>
<script>
  import InputSwitch from 'primevue/inputswitch';
  import Dropdown from "primevue/dropdown";
  import RuleRaiseGroup from "./RuleRaiseGroup.vue";

  export default {
    name: 'StageDynamicBudget',
    props: {
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      stageContent:{
        type: Object
      },
      currencyList: {
        type: Object
      },
      lang: {
        type: Object
      },
    },
    components: {
      InputSwitch,
      Dropdown,
      RuleRaiseGroup
    },
    data() {
      return {
        useDynBudget: false,
        compareType: [
          { name: '大於', code: 'GREATER_THAN'},
          { name: '大於等於', code: 'GREATER_THAN_EQUAL'},
          { name: '等於', code: 'EQUAL'},
          { name: '小於等於', code: 'LESS_THAN_EQUAL'},
          { name: '小於', code: 'LESS_THAN'},
        ],
        field: [
          { name: 'CPA', code: '7D_CPA'},
          { name: 'ROAS', code: '7D_ROAS'},
        ],
        ruleFrequencyConditionCount: 0,
        canRaiseAddCondition: true,
        frequency: '1d',
        timeType: [
          { name: '1天', code: '1d'},
          { name: '3天', code: '3d'},
          { name: '7天', code: '7d'},
        ],
      }
    },
    created() {

    },
    watch:{
      'viewDatalistData.useDynamicBudget':function(v){
        console.log('viewDatalistData.useDynamicBudget');
        console.log(v);
      },
    },
    methods: {
      changeDataFilters(updateData) {
        console.log('changeDataFilters updateData:', updateData);
        // this.testList = updateData; // 接收子元件傳遞來的資料並更新
        // console.log('testList:', this.testList);
        console.log('b forwardData.rule_frequency:', this.viewDatalistData.budgetDynamicRuleRaise);
        this.viewDatalistData.budgetDynamicRuleRaise = updateData;
        console.log('a forwardData.rule_frequency:', this.viewDatalistData.budgetDynamicRuleRaise);
        this.ruleFrequencyConditionCount = this.countConditions(this.viewDatalistData.budgetDynamicRuleRaise.filters);
        console.log('ruleFrequencyConditionCount:', this.ruleFrequencyConditionCount);

        this.updateConditionCount();
      },
      countConditions(filters) {
        console.log('countConditions');
        console.log(filters);
        let count = 0;

        const countRecursive = (filtersList) => {
          if (!filtersList || !Array.isArray(filtersList)) {
            // 如果 filtersList 为空或不是数组，则直接返回
            return;
          }

          filtersList.forEach((filter) => {
            if (filter.filters && Array.isArray(filter.filters)) {
              // 如果有子条件组，递归计算
              countRecursive(filter.filters);
            } else {
              // 否则是一条条件，增加数量
              count++;
            }
          });
        };

        countRecursive(filters);
        return count;
      },
      updateConditionCount() {
        console.log('updateConditionCount');
        this.ruleFrequencyConditionCount = this.countConditions(
          this.viewDatalistData.budgetDynamicRuleRaise.filters
        );
        console.log('ruleFrequencyConditionCount:', this.ruleFrequencyConditionCount);
        // this.canAddCondition = this.ruleFrequencyConditionCount < 4;
      },
      validateInput(){
        let value = this.viewDatalistData.budgetDynamicRuleRaise[0].pct_dynamic;

        console.log('this.viewDatalistData.budgetDynamicRuleRaise', this.viewDatalistData.budgetDynamicRuleRaise);
        console.log('validateInput', value);

        // 限制范围在 0 到 100 之间
        if (value > 100) {
          value = 100;
        } else if (value < 0) {
          value = 0;
        }

        this.viewDatalistData.budgetDynamicRuleRaise[0].pct_dynamic = value;

        console.log('this.viewDatalistData.budgetDynamicRuleRaise.times', this.viewDatalistData.budgetDynamicRuleRaise[0].pct_dynamic);
      },
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      stageContenttData:{
        get: function () {
          return this.stageContent
        },
        set: function (value) {
          this.$emit('update:stageContenttData', value)
        },
      },
      currencyListData: {
        get: function () {
          return this.currencyList
        },
        set: function (value) {
          this.$emit('update:currencyListData', value)
        },
      },
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>